import moment from 'moment';
import { postAllData } from '../service/ProductService';
import { bookAppointmentApplication, monthShortNames } from './Settings';

export const DEFAULT_TIMEZONE = 'America/New_York';

export const convertUTCtoTimeZone = function (date: any, timeZone = getTimeZone()) {
    // return date ? moment.utc(date).tz(timeZone).format('DD MMM YYYY, hh:mm A') : null;
};
// convert local time to UTC time
export const convertLocalToUTC = (date: any) => {
    return moment(date, 'YYYY-MM-DD hh:mm:ss').utc().format('YYYY-MM-DD HH:mm:ss');
};

export const convertDateTime = (date: any) => {
    return moment(date).format('DD MMMM YYYY h:mm A');
};

export const ConvertGMTIST = function (date: any) {
    return date ? moment.utc(date).local().format('DD MMM YYYY') : null;
};

// Format Date
export const formatDate = function (date: any) {
    return date ? moment.utc(date).format('DD MMM YYYY') : '';
};

export const formatDateTime = function (date: any) {
    return date ? moment.utc(date).format('DD MMM YYYY') : null;
};

export const formatMonth = function (date: any) {
    return date ? moment.utc(date).format('MMM YYYY') : null;
};

export const parseDDMMYYYY = (dateStr: string | null) => {
    if (!dateStr) return null;

    const [dd, mm, yyyy] = dateStr.split('/');
    return new Date(Number(yyyy), Number(mm) - 1, Number(dd));
};

// Format Date in YYYY-MM-DD
export const formatYearMonthDate = function (date: any) {
    return date ? moment(date).format('YYYY-MM-DD') : null;
};

// Get Specific Single Year for Accouting
export const convertSingleYear = (date: any) => {
    let currentDate = new Date(date);
    let year = currentDate.getFullYear();
    let accoutClosingDate = new Date(year + '-03-31');

    if (currentDate > accoutClosingDate) {
        return year;
    } else if (currentDate <= accoutClosingDate) {
        return year - 1;
    }
};

export const getApplicationValue = (id: any) => {
    let Apptype: any = bookAppointmentApplication.find((item: any) => {
        return id === item.code;
    });
    return Apptype.name;
};

export const getTimeZone = function () {
    let timezone;
    var pageUrl = window.location.href;
    if (pageUrl.indexOf('/admin/') > 0) {
        timezone = DEFAULT_TIMEZONE;
    } else {
        if (localStorage.getItem('timezone') && localStorage.getItem('timezone') !== null) {
            timezone = localStorage.getItem('timezone');
        }
    }
    return timezone;
};

export const createMarkup = (converdata: any) => {
    return { __html: converdata };
};

export const dateFormatTemplate = (rowData: any, rowIndex: any) => {
    return <>{rowData.created_at === rowData[rowIndex.field] ? moment.utc(rowData.created_at).format('MMM DD, YYYY') : rowData[rowIndex.field]}</>;
};

export const getAction = (pageName: any) => {
    const assignedAction: any = localStorage.getItem('assigned_actions') ? localStorage.getItem('assigned_actions') : '';

    const assignedActions: any = JSON.parse(assignedAction);

    // var myArray = JSON.parse(assignedActions)

    const filteredAction = assignedActions.find((action: any) => action.menu === pageName);

    if (!filteredAction) {
        // Return empty if no match is found
        return null;
    }

    // Get keys with value 1
    const result = Object.keys(filteredAction)
        .filter((key) => filteredAction[key] === 1 || key === 'menu') // Include the "menu" field always
        .reduce((acc, key) => ({ ...acc, [key]: filteredAction[key] }), {});

    return result;
};

// Set Fresh / Fresh Other / Transfer Application Status
export const setAppStatus = (status: any) => {
    let statusData: any = {};
    if (status === 'Pending') {
        statusData.value = 'Pending';
        statusData.severity = 'warning';
    } else if (status === 'Verification') {
        statusData.value = 'Verification';
        statusData.severity = 'warning';
    } else if (status === 'Approved') {
        statusData.value = 'Approved';
        statusData.severity = 'success';
    } else if (status === 'Scrutiny Prepare') {
        statusData.value = 'Scrutiny Prepare';
        statusData.severity = 'success';
    } else if (status === 'Scrutiny Check') {
        statusData.value = 'Scrutiny Check';
        statusData.severity = 'success';
    } else if (status === 'Rejected') {
        statusData.value = 'Rejected';
        statusData.severity = 'danger';
    } else if (status === 'Hold') {
        statusData.value = 'Hold';
        statusData.severity = 'info';
    } else if (status === 'DocUnverified') {
        statusData.value = 'Documents : Not Proper';
        statusData.severity = 'warning';
    } else if (status === 'DocReverified') {
        statusData.value = 'Documents : Reuploaded';
        statusData.severity = 'warning';
    } else if (status === 'DocInVerification') {
        statusData.value = 'Documents : Under review';
        statusData.severity = 'warning';
    } else if (status === 'DocVerified') {
        statusData.value = 'Documents : OK';
        statusData.severity = 'warning';
    } else if (status === 'Appointment Booked') {
        statusData.value = 'Appointment Booked';
        statusData.severity = 'info';
    }
    return statusData;
};

// Set Other Application Status
export function setOtherAppStatus(status: any) {
    let statusData: any = {};
    if (status == 0) {
        statusData.value = 'Pending';
        statusData.severity = 'warning';
    } else if (status == 1) {
        statusData.value = 'Approved';
        statusData.severity = 'success';
    } else if (status == 2) {
        statusData.value = 'Rejected';
        statusData.severity = 'danger';
    } else if (status == 3) {
        statusData.value = 'Hold';
        statusData.severity = 'info';
    } else if (status == 4) {
        statusData.value = 'Documents : Not Proper';
        statusData.severity = 'warning';
    } else if (status == 5) {
        statusData.value = 'Documents : Reuploaded';
        statusData.severity = 'warning';
    }
    return statusData;
}

// Check Role and Return Tab
export const setScrutinyActiveTab = (roleName: any) => {
    let activeTab = 0;
    if (roleName === 'Registar') {
        activeTab = 2;
    } else if (roleName === 'Sub Registar') {
        activeTab = 1;
    } else {
        activeTab = 0;
    }
    return activeTab;
};

//set Admin Image
export const setAdminProfile = (adminName: any) => {
    let imageUrl: any;
    if (adminName === 'Bhavika Modi') {
        imageUrl = 'https://gujaratpharmacycouncil-2.s3.ap-south-1.amazonaws.com/Council+Staff/BHAVIKA+B+MODI.jpeg';
    } else if (adminName === 'Aaditya Solanki' || adminName === 'Aaditya Solanki2') {
        imageUrl = 'https://gujaratpharmacycouncil-2.s3.ap-south-1.amazonaws.com/Council+Staff/MR+ADITYA+M+SOLANKI.jpeg';
    } else if (adminName === 'Niketa Patel') {
        imageUrl = 'https://gujaratpharmacycouncil-2.s3.ap-south-1.amazonaws.com/Council+Staff/MRS+NIKETA+C+PATEL.jfif';
    } else if (adminName === 'Bhupendra Patel') {
        imageUrl = 'https://gujaratpharmacycouncil-2.s3.ap-south-1.amazonaws.com/Council+Staff/MR+BHUPENDRA+A+PATEL.jpeg';
    } else if (adminName === 'Mayur Solank') {
        imageUrl = 'https://gujaratpharmacycouncil-2.s3.ap-south-1.amazonaws.com/Council+Staff/MR+MAYUR+P+SOLANKI.jfif';
    } else if (adminName === 'Gilbert Macwan') {
        imageUrl = 'https://gujaratpharmacycouncil-2.s3.ap-south-1.amazonaws.com/Council+Staff/MR+GILBERT+C+MACWAN.jfif';
    } else if (adminName === 'Minaxi Verma') {
        imageUrl = 'https://gujaratpharmacycouncil-2.s3.ap-south-1.amazonaws.com/Council+Staff/MRS+MINAXI+R+VERMA.jfif';
    } else if (adminName === 'Mohini Patel') {
        imageUrl = 'https://gujaratpharmacycouncil-2.s3.ap-south-1.amazonaws.com/Council+Staff/MRS+MOHINI+A+PATEL.jpeg';
    } else if (adminName === 'Sonal Patel') {
        imageUrl = 'https://gujaratpharmacycouncil-2.s3.ap-south-1.amazonaws.com/Council+Staff/MRS+SONAL+A+PATEL.jfif';
    } else if (adminName === 'Preeti Patel') {
        imageUrl = 'https://gujaratpharmacycouncil-2.s3.ap-south-1.amazonaws.com/Council+Staff/PREETI+H+PATEL.jfif';
    } else if (adminName === 'Sahil Yadav') {
        imageUrl = 'https://gujaratpharmacycouncil-2.s3.ap-south-1.amazonaws.com/Council+Staff/SAHIL+C+YADAV.jfif';
    }

    return imageUrl;
};

//getStatusFor History
export const setStatusHistory = (status: any) => {
    let statusBadge: any;
    if (status == 0) {
        statusBadge = 'Pending';
    } else if (status == 1) {
        statusBadge = 'Approved';
    } else if (status == 2) {
        statusBadge = 'Rejected';
    } else if (status == 3) {
        statusBadge = 'Hold';
    } else if (status == 4) {
        statusBadge = 'Documents : Not Proper';
    } else if (status == 5) {
        statusBadge = 'Documents : Reuploaded';
    }

    return statusBadge;
};

//Check email in localstorage
export const checkEmail = (mail: any) => {
    if (mail === 'prayer.gilbat@gmail.com' || mail === 'sonal201184@gmail.com') {
        return true;
    } else {
        return false;
    }
};

//Check email pre application
export const checkEmailPreApplication = (mail: any) => {
    if (mail === 'sonal201184@gmail.com') {
        return true;
    } else {
        return false;
    }
};

// Download data
export const downloadData = async (APIName: any, fileName: any, requestData: any) => {
    const file = `${fileName}-${new Date().getTime()}.csv`;
    var status = false;
    try {
        const response = await postAllData(APIName, requestData);
        if (!window.cn(response?.data) || !window.cn(response?.data?.data)) {
            status = true;

            let file_url;

            if (!window.cn(response?.data?.data)) {
                file_url = response?.data.data;
            } else {
                file_url = response?.data;
            }

            //PDF Download
            const link = document.createElement('a');

            link.href = file_url;
            link.target = '_blank';
            link.download = file;
            document.body.appendChild(link);
            link.click();
        }
    } catch (error: any) {
        status = false;
    }
    return status;
};

//Export CSV
export const exportData = async (fileName: any) => {
    const file = `${fileName}-${new Date().getTime()}.csv`;
    var status;
    var csv = [];
    var rows = document.querySelectorAll('table tr');

    //All Table Row
    for (var i = 0; i < rows.length; i++) {
        var row = [],
            cols: any = rows[i].querySelectorAll('td, th');

        for (var j = 0; j < cols.length; j++) {
            const trimValue = cols[j].innerText.replace(/,/g, '');
            row.push(trimValue);
        }

        csv.push(row.join(','));
    }
    if (csv.length > 0) {
        status = true;
    } else {
        status = false;
    }
    // Download CSV
    download_csv(csv.join('\n'), file);

    return status;
};

//Download CSV
export const download_csv = (csv: any, filename: any) => {
    var csvFile, downloadLink;

    // CSV FILE
    csvFile = new Blob([csv], { type: 'text/csv' });

    // Download link
    downloadLink = document.createElement('a');

    // File name
    downloadLink.download = filename;

    // We have to create a link to the file
    downloadLink.href = window.URL.createObjectURL(csvFile);

    // Make sure that the link is not displayed
    downloadLink.style.display = 'none';

    // Add the link to your DOM
    document.body.appendChild(downloadLink);

    // Lanzamos
    downloadLink.click();
};

// Set Refresher course status
export function setRefresherCourseStatus(status: any) {
    let statusData: any = {};
    if (status === 'Open') {
        statusData.value = 'Open';
        statusData.severity = 'warning';
    } else if (status === 'Completed') {
        statusData.value = 'Completed';
        statusData.severity = 'success';
    } else if (status === 'Booked') {
        statusData.value = 'Booked';
        statusData.severity = 'success';
    } else if (status === 'Closed') {
        statusData.value = 'Closed';
        statusData.severity = 'danger';
    }
    return statusData;
}

// Set Refresher course publish status
export function setRefresherCoursePublishStatus(status: any) {
    let statusData: any = {};
    if (status == 0) {
        statusData.value = 'Inactive';
        statusData.severity = 'danger';
    } else if (status == 1) {
        statusData.value = 'Active';
        statusData.color = 'success';
    }
    return statusData;
}

// Get Specific Accouting Year
export const convertYearforAccouting = (date: any) => {
    let currentDate = new Date(date);
    let year = currentDate.getFullYear();
    let accoutClosingDate = new Date(year + '-03-31');

    if (currentDate > accoutClosingDate) {
        return year + '' + (year + 1);
    } else if (currentDate <= accoutClosingDate) {
        return year - 1 + '' + year;
    }
};

//Accounting Year Convert
export const convertAccoutingYear = (date: any) => {
    date = new Date(date);
    let year = date.getFullYear();

    return year + '-' + (year + 1);
};

// Set Job Application Status
export function setJobAppStatus(status: any) {
    let statusData: any = {};
    if (status === 'deactive') {
        statusData.value = 'Deactive';
        statusData.severity = 'danger';
    } else {
        statusData.value = 'Active';
        statusData.severity = 'success';
    }
    return statusData;
}

//amountformage
export const amountFormate = (amt: any) => {
    let amount: any = '';
    // amount = "₹" + Math.floor(amt).toLocaleString();
    amount = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(amt);

    return amount;
};

//Date Convert
export function convertDate(date: any) {
    date = new Date(date); //Date pass
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();

    return (day <= 9 ? '0' + day : day) + '/' + (month <= 9 ? '0' + month : month) + '/' + year;
}

//Month Convert
export function convertMonthFormat(date: any) {
    date = new Date(date); //Date pass
    let month = date.getMonth();
    let year = date.getFullYear();

    return monthShortNames[month] + '-' + year;
}

export const dynamicMenuSections = [
    {
        label: 'Other Application',
        permissionKey: 'Other Application',
        config: [
            { key: 'Address Change', to: '/app/application/address-change' },
            { key: 'Name Change', to: '/app/application/name-change' },
            { key: 'Good Standing Application', to: '/app/application/goodstanding-application-list' },
            { key: 'Duplicate Certificate', to: '/app/application/duplicate-certificate-application-list' },
            { key: 'Registration Cancellation', to: '/app/application/registration-cancellation' },
            { key: 'Degree Additional', to: '/app/application/degree-addition' },
            { key: 'Provisional To Original', to: '/app/application/pro-to-org-application' },
            { key: 'Penalty', to: '/app/application/penlty' },
            { key: 'Search', to: '/app/application/search' }
        ]
    },
    {
        label: 'Refresher Course',
        permissionKey: 'Refresher Course',
        config: [
            { key: 'Online Refresher Course', to: '/app/refresher-course-list' },
            { key: 'Offline Refresher Course', to: '/app/offline-refresher-course-list' }
        ]
    },
    {
        label: 'Certificates',
        permissionKey: 'Certificates',
        config: [
            { key: 'Provisional Certificate', to: '/app/certificate/provisional-certificate' },
            { key: 'Original Certificate', to: '/app/certificate/original-certificate' },
            { key: 'Duplicate Certificate', to: '/app/certificate/duplicate-certificate' },
            { key: 'Additional Certificate', to: '/app/certificate/additional-certificate' },
            { key: 'Good Standing Certificate', to: '/app/certificate/goodstanding-certificate' },
            { key: 'Registration Date Update', to: '/app/certificate/registration-date-update' }
        ]
    }
];

// utils/menuHelper.ts
export const updateFirstAccessiblePath = (menuList: any[], targetLabel: string, permissionKey: string, menuConfig: { key: string; to: string }[], assignedActions: any[]): any[] => {
    return menuList.reduce((acc: any[], item) => {
        if (item.label === targetLabel && item.items) {
            const permission = assignedActions.find((i) => i.menu === permissionKey);
            if (!permission) return acc; // no access at all to this menu

            const allowedItems = menuConfig.filter((i) => permission[i.key] === 1);

            if (allowedItems.length === 0) return acc; // hide this menu entirely

            // Set the first accessible `to`
            const updatedItem = {
                ...item,
                to: allowedItems[0].to,
                items: updateFirstAccessiblePath(item.items, targetLabel, permissionKey, menuConfig, assignedActions)
            };

            return [...acc, updatedItem];
        }

        if (item.items) {
            const updatedChildren = updateFirstAccessiblePath(item.items, targetLabel, permissionKey, menuConfig, assignedActions);
            if (updatedChildren.length > 0) {
                acc.push({
                    ...item,
                    items: updatedChildren
                });
            }
        } else {
            acc.push(item);
        }

        return acc;
    }, []);
};
